import { jsx } from "react/jsx-runtime";
import React__default from "react";
import { g as getIllustration } from "./utils.js";
import { AnalyticsId } from "./constants.js";
import { useUuid } from "./hooks/useUuid.js";
var ViewBoxSize = /* @__PURE__ */ ((ViewBoxSize2) => {
  ViewBoxSize2["Medium"] = "0 0 512 512";
  ViewBoxSize2["Small"] = "0 0 200 200";
  return ViewBoxSize2;
})(ViewBoxSize || {});
const Illustration = React__default.forwardRef((props, ref) => {
  const { illustration, ariaLabel, className = "", size = 512, color = "neutral", testId, ...other } = props;
  const titleId = useUuid();
  const viewBox = getIllustration({
    size,
    medium: "0 0 512 512",
    small: "0 0 200 200"
    /* Small */
  });
  const svgProperties = {
    "data-testid": testId,
    "data-analyticsid": AnalyticsId.Illustration,
    ref,
    className,
    role: ariaLabel ? "img" : "presentation",
    "aria-labelledby": ariaLabel ? titleId : void 0,
    focusable: false,
    "aria-hidden": ariaLabel ? void 0 : true,
    viewBox,
    style: { minWidth: size, minHeight: size },
    width: size,
    height: size,
    fill: color,
    ...other
  };
  const svgElement = React__default.createElement(illustration, {
    size,
    color,
    svgProperties,
    title: ariaLabel && /* @__PURE__ */ jsx("title", { id: titleId, children: ariaLabel })
  });
  return svgElement;
});
Illustration.displayName = "Illustration";
export {
  Illustration as I,
  ViewBoxSize as V
};
//# sourceMappingURL=Illustration.js.map
